import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { ArrowLeft, CheckCircle2, Loader2, XCircle } from "lucide-react";

const fmtIssued = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso);
  return isNaN(d.getTime()) ? iso : d.toLocaleDateString("id-ID", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
};

export default function SuratVerify() {
  const { suratId } = useParams();
  const [data, setData] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api
      .get(`/public/surat/${suratId}`)
      .then((r) => setData(r.data))
      .catch(() => setNotFound(true));
  }, [suratId]);

  return (
    <div className="min-h-screen bg-slate-50" data-testid="surat-verify-page">
      <header className="border-b border-slate-200 bg-white/90 backdrop-blur">
        <div className="mx-auto flex max-w-xl items-center gap-3 px-4 py-3">
          <Link to="/">
            <img src="/logo-lazisnu.png" alt="Logo LAZISNU Dawe" className="h-10 w-10 rounded-lg bg-white object-contain p-0.5" />
          </Link>
          <div className="flex-1">
            <p className="font-heading font-bold text-slate-900 leading-tight">Verifikasi Surat Layanan</p>
            <p className="text-xs text-slate-500">NU Care LAZISNU Kecamatan Dawe</p>
          </div>
          <Link to="/">
            <Button variant="outline" size="sm" data-testid="surat-back-button">
              <ArrowLeft className="mr-1.5 h-4 w-4" /> Beranda
            </Button>
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-xl px-4 py-10">
        {!data && !notFound && (
          <div className="flex justify-center py-16">
            <Loader2 className="h-8 w-8 animate-spin text-emerald-800" />
          </div>
        )}

        {notFound && (
          <Card>
            <CardContent className="p-10 text-center" data-testid="surat-invalid">
              <XCircle className="mx-auto mb-4 h-14 w-14 text-red-500" />
              <h1 className="font-heading text-xl font-bold text-slate-900">Surat Tidak Ditemukan</h1>
              <p className="mt-2 text-sm text-slate-500">Kode surat tidak valid atau dokumen tidak diterbitkan oleh sistem LAZISNU Dawe.</p>
            </CardContent>
          </Card>
        )}

        {data && (
          <Card className="border-emerald-200">
            <CardContent className="p-8" data-testid="surat-valid">
              <div className="text-center mb-6">
                <CheckCircle2 className="mx-auto mb-3 h-14 w-14 text-emerald-700" />
                <h1 className="font-heading text-xl font-bold text-emerald-900">Surat Terverifikasi Asli</h1>
                <p className="mt-1 text-xs text-slate-500">Dokumen ini diterbitkan oleh Sistem Informasi LAZISNU Dawe</p>
              </div>
              <div className="space-y-3 rounded-xl border border-slate-200 bg-slate-50 p-5">
                <div className="flex justify-between text-sm">
                  <span className="text-slate-500">Jenis Surat</span>
                  <span className="font-semibold text-slate-900" data-testid="surat-jenis">{data.jenis_label}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-slate-500">Nama</span>
                  <span className="font-semibold text-slate-900" data-testid="surat-nama">{data.nama}</span>
                </div>
                {(data.fields || []).map(([k, v]) => (
                  <div key={k} className="flex justify-between gap-4 text-sm">
                    <span className="text-slate-500 shrink-0">{k}</span>
                    <span className="font-semibold text-slate-900 text-right">{v}</span>
                  </div>
                ))}
                <div className="flex justify-between text-sm border-t border-slate-200 pt-3">
                  <span className="text-slate-500">Tanggal Terbit</span>
                  <span className="font-semibold text-slate-900">{fmtIssued(data.issued_at)}</span>
                </div>
                <div className="flex justify-between text-sm">
                  <span className="text-slate-500">No. Surat</span>
                  <span className="font-mono text-xs text-slate-600">{data.surat_id}</span>
                </div>
              </div>
            </CardContent>
          </Card>
        )}
      </main>
    </div>
  );
}
